import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  Router,
  RouterOutlet,
} from '@angular/router';
import { filter, map, take } from 'rxjs';

import { BackendWakeupService } from './services/backend-wakeup.service';
import { SplashScreenComponent } from './components/splash-screen/splash-screen.component';

@Component({
  selector: 'app-host-root',
  standalone: true,
  imports: [RouterOutlet, SplashScreenComponent],
  template: `
    @if (showSplash()) {
      <app-splash-screen [error]="backendWakeupService.error()" />
    } @else {
      <router-outlet />
    }
  `,
})
export class AppComponent {
  protected readonly backendWakeupService = inject(BackendWakeupService);
  private readonly router = inject(Router);

  /**
   * The first navigation has settled, one way or another. Cancel and error
   * count: a splash that never comes down is worse than no splash at all.
   */
  private readonly firstNavigationSettled = toSignal(
    this.router.events.pipe(
      filter(
        (event) =>
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
      ),
      take(1),
      map(() => true)
    ),
    { initialValue: false }
  );

  /**
   * Waking the backend is only half the wait — the first route's lazy chunk is
   * still downloading when it answers. Dropping the splash there leaves a blank
   * page, so hold it until something is actually on screen.
   */
  protected readonly showSplash = computed(
    () => !this.backendWakeupService.isBackendReady() || !this.firstNavigationSettled()
  );
}
